module.exports = __webpack_public_path__ + "img/IMG_20191125_200644.2ff4276b.jpg";